import { Api } from '../api'

const getFacilities = (projectId) => {
    return Api.get(`/facility/${projectId ? projectId : ''}`);
};

const transferFacilities = (projectId, sourceFacilityId, destinationFacilityId) => {
    const body = {
        projectId: Number(projectId),
        sourceFacilityId: Number(sourceFacilityId),
        destinationFacilityId: Number(destinationFacilityId)
    };

    return Api.post(`/facility/transfer`, body);
};

export default {
    getFacilities,
    transferFacilities
};